import { render, staticRenderFns } from "./MediaComponent.vue?vue&type=template&id=2bf20162&"
import script from "./MediaComponent.vue?vue&type=script&lang=js&"
export * from "./MediaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports